/* eslint-disable react-hooks/exhaustive-deps */
import valueNotFoundpng from "@assets/images/value-not-found.png";
import { Locale, Path } from "@common/constans";
import { FeedBackStatus, IFeedback, IGResponse } from "@common/models";
import { IContactPoint } from "@common/models/CMS";
import { Comment, IComment } from "@common/models/Comment";
import { IFeedbackDetailsRequest } from "@common/models/FeedbackDetailsRequest";
import { planePage } from "@config/route";
import { Culture, IValidationError } from "@core/index";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import { CONTACT_POINT, useApolloQuery } from "@service/graphql";
import Notification from "@service/Notification";
import { Action, feedbackCreateComment, feedbackDetails } from "@service/proxy";
import Translate from "@service/Translate";
import { formatToBase64, formatToDateTime } from "@utilize/Format";
import { validationMessage } from "@utilize/Util";
import { FC, Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import BeautyDate from "../general/BeautyDate";
import Button from "../general/form/Button";
import FileInput, { IBase64 } from "../general/form/FileInput";
import TextArea from "../general/form/TextArea";
import Icon, { IconMode } from "../general/Icon";
import Label from "../general/Label";
import People from "../general/People";
import ValueNotFound from "../general/ValueNotFound";

export interface IFeedbackDetailsProps { }

const FeedbackDetails: FC<IFeedbackDetailsProps> = () => {
    const { tr } = Translate;
    const { push } = useHistory();
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const IrLocale = Culture.getLocale(Locale.fa);
    const { lang } = Culture.getLocale();
    const query = new URLSearchParams(useLocation().search);
    const dateTimeFormat: string = "H:i l d M";
    const { feedback, user } = useSelector((state: IAppState) => ({
        feedback: state.feedback,
        user: state.user
    }))
    const { data: contactPointRes } = useApolloQuery<IGResponse<IContactPoint[]>>(CONTACT_POINT);
    const [validationError, setValidationError] = useState<IValidationError>();
    const [comment, setComment] = useState<(IComment)>({ attachments: [] });
    const [showCreateCommentLoading, setShowCreateCommentLoading] = useState<boolean>(false);

    const formErrorsMessages = {
        description: {
            required: tr("err_record_required", "comment")
        }
    };

    useEffect(() => {
        if (!feedback.typeId) {
            const participateRequest: IFeedbackDetailsRequest = {
                feedbackId: query.get("feedbackId") || "",
                participationId: query.get("participationId") || ""
            }
            dispatch<IAppAction>({ type: AppAction.Preloader, payload: { preloader: { show: true } } });
            feedbackDetails(Action.POST, { data: participateRequest })
                .then((response) => {
                    dispatch<IAppAction>({ type: AppAction.FeedBack, payload: { feedback: response.content as IFeedback } });
                })
                .finally(() => dispatch<IAppAction>({ type: AppAction.Preloader, payload: { preloader: { show: false } } }));
        }
    }, []);

    const onFileAttachmentsChange = (name: string, value: File[]) => {
        value.forEach((v) => {
            formatToBase64(v)
                .then((res) => {
                    const attachment: IBase64 = {
                        content: res as string,
                        fileName: v.name,
                        fileSize: v.size,
                        fileType: v.type,
                        creationTime: v.lastModified
                    }
                    comment?.attachments?.push(attachment);
                    setComment({ ...comment });
                })
        });
    }

    const onCommentChange = (name: string, value: any) => {
        comment[name as keyof IComment] = value;
        setComment({ ...comment });
    }

    const removeValidation = (name: string, value: any) => {
        if (validationError)
            delete validationError[name];
        setValidationError({ ...validationError });
    }

    const onCreateCommentClick = () => {
        let error = new Comment(comment).validate() || {};
        if (Object.keys(error).length)
            return setValidationError({ ...error });
        setValidationError({});
        setShowCreateCommentLoading(true);
        const commentRequest: IComment = {
            feedback: {
                participation: { id: feedback.participation?.id },
                referenceId: feedback.referenceId
            },
            description: comment.description,
        }
        if (comment.attachments?.length)
            commentRequest.attachments = comment.attachments;
        feedbackCreateComment(Action.POST, { data: commentRequest })
            .then((response) => {
                Notification.success(tr("feedback_submit_successful"));
                feedback.comments?.push(response.content as IComment);
                dispatch<IAppAction>({ type: AppAction.FeedBack, payload: { feedback: { ...feedback } } });
                setComment({ attachments: [] });
            })
            .catch((error) => { })
            .finally(() => {
                setShowCreateCommentLoading(false);
            })
    }

    const showLocalName = lang === IrLocale.lang && feedback.assignee?.localFirstName && feedback.assignee?.localLastName ?
        `${feedback.assignee?.localFirstName} ${feedback.assignee?.localLastName}` :
        `${feedback.assignee?.firstName} ${feedback.assignee?.lastName}`;

    const error = validationError ? validationMessage(formErrorsMessages, validationError) : {};

    return (
        <div className={`feedback-details${planePage.includes(pathname) ? " plane-page" : ""}`}>
            <div className="container">
                {
                    feedback.referenceId ?
                        <Fragment>
                            <div className="feedback-details-header">
                                <div className="feedback-details-header-item">
                                    {
                                        user.memberId && !planePage.includes(pathname) ? <Icon
                                            className="feedback-details-header-back-btn"
                                            name="icon-backward"
                                            multi
                                            onClick={() => push(Path.Profile.Feedbacks)}
                                        />
                                            : ""
                                    }
                                    <div className="feedback-details-header-main flex flex-center">
                                        <h2 className="feedback-details-header-title">
                                            {contactPointRes?.feedbackType?.find(c => c.code?.code === feedback?.typeId?.toString())?.displayText}
                                        </h2>
                                        <div className="feedback-details-header-id en">({feedback.referenceId})</div>
                                    </div>
                                </div>
                                <div className="feedback-details-header-item">
                                    <div className="feedback-details-header-date">
                                        <div className="feedback-details-header-date-title">
                                            <Icon name="icon-calendar-outline" />
                                            <span>{tr("feedback_time_create")}</span>
                                        </div>
                                        <div className="feedback-details-header-date-value">
                                            <BeautyDate date={feedback.created || 0} format={dateTimeFormat} />
                                        </div>
                                    </div>
                                    {
                                        feedback.updated ?
                                            <div className="feedback-details-header-date">
                                                <div className="feedback-details-header-date-title">
                                                    <Icon name="icon-calendar-outline" />
                                                    <span>{tr("feedback_time_update")}</span>
                                                </div>
                                                <div className="feedback-details-header-date-value">
                                                    <BeautyDate date={feedback.updated} format={dateTimeFormat} />
                                                </div>
                                            </div>
                                            : ""
                                    }
                                </div>
                            </div>
                            <div className="feedback-details-content">
                                <div className="row flex">
                                    <div className="col-2-3 col-md-1-1 col-sm-1-1 mg-b-15 feedback-details-content-main">
                                        <div className="feedback-details-content-details">
                                            <div className="feedback-details-content-item-header">{tr("details")}</div>
                                            <div className="feedback-details-content-item">
                                                <div className="feedback-details-content-item-title">{tr("status")}:</div>
                                                <div className="feedback-details-content-item-value">
                                                    <span className={`feedback-status-${String(FeedBackStatus[feedback.status as number]).toLowerCase()}`}>
                                                        {tr(`feedback_status_${String(FeedBackStatus[feedback.status as number]).toLowerCase()}`)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="feedback-details-content-item">
                                                <div className="feedback-details-content-item-title">{tr("subject")}:</div>
                                                <div className="feedback-details-content-item-value">
                                                    {contactPointRes?.feedbackCategory?.find(c => c.code?.code === feedback?.categoryId?.toString())?.displayText}
                                                </div>
                                            </div>
                                            <div className="feedback-details-content-item reporter">
                                                <div className="feedback-details-content-item-title">{tr("feedback_reporter")}:</div>
                                                <div className="feedback-details-content-item-value ltr trim">{feedback.participation?.firstName} {feedback.participation?.lastName}</div>
                                            </div>
                                            <div className="feedback-details-content-item">
                                                <div className="feedback-details-content-item-title">{tr("phone")}:</div>
                                                <div className="feedback-details-content-item-value">{lang !== IrLocale.lang ? feedback.phoneNumber?.internationalCode : ""} {feedback.phoneNumber?.phoneNumber}</div>
                                            </div>
                                            <div className="feedback-details-content-item email">
                                                <div className="feedback-details-content-item-title">{tr("email")}:</div>
                                                <div className="feedback-details-content-item-value trim ltr en">{feedback?.email?.emailAddress}</div>
                                            </div>
                                            <div className="feedback-details-content-item description">
                                                <div className="feedback-details-content-item-title">{tr("feedback_user_description")}:</div>
                                                <div className="feedback-details-content-item-value feedback-details-description">{feedback.description || "-"}</div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        feedback.assignee?.firstName ? <div className="col-1-3 col-md-1-1 col-sm-1-1 mg-b-15 feedback-details-content-sidebar">
                                            <div className="feedback-details-content-item-header">{tr("feedback_assignee")}</div>
                                            <div className="feedback-details-content-item assignee">
                                                <div className="feedback-details-content-item-title">
                                                    <People
                                                        name={showLocalName}
                                                        avatar={feedback.assignee?.avatar}
                                                    />
                                                </div>
                                                <div className="feedback-details-content-item-value flex flex-center">
                                                    <Label
                                                        icon="icon-phone"
                                                        mode="inline"
                                                        size="medium"
                                                        className="ltr"
                                                        text={
                                                            <a href={`tel:0${lang !== IrLocale.lang ? feedback.assignee?.telephone?.internationalCode : ""}${feedback.assignee?.telephone?.areaCode}${feedback.assignee?.telephone?.phoneNumber?.replace(" ", "")}`}>
                                                                {lang !== IrLocale.lang ? feedback.assignee?.telephone?.internationalCode : ""} {feedback.assignee?.telephone?.areaCode} {feedback.assignee?.telephone?.phoneNumber}
                                                            </a>
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                            : ""
                                    }

                                </div>
                                {
                                    feedback.attachments?.length ? <div className="row flex attachment">
                                        <div className="col-2-3 col-md-1-1 col-sm-1-1 mg-b-15">
                                            <div className="feedback-details-content-item-header">{tr("attachment")}</div>
                                            <FileInput
                                                multiple
                                                readonly
                                                value={feedback.attachments}
                                            />
                                        </div>
                                    </div>
                                        : ""
                                }
                                {
                                    feedback.comments?.length ?
                                        <div className="row flex">
                                            <div className="col-2-3 col-md-1-1 col-sm-1-1 mg-b-15">
                                                <div className="feedback-details-content-item-header">{tr("messages")}</div>
                                                <div className="feedback-details-comments">
                                                    {
                                                        feedback.comments?.map((comment, index) =>
                                                            <div key={index} className="comment">
                                                                <div className="comment-header">
                                                                    <div className="comment-header-item title">
                                                                        {
                                                                            comment.author?.firstName ?
                                                                                <People
                                                                                    name={`${showLocalName}`}
                                                                                    avatar={comment.author?.avatar}
                                                                                    bold
                                                                                />
                                                                                : tr("feedback_your_comment")
                                                                        }

                                                                    </div>
                                                                    <div className="comment-header-item comment-created-date">
                                                                        <div>{formatToDateTime(comment.created as number, { format: dateTimeFormat })}</div>
                                                                        <Icon name="icon-calendar-outline" />
                                                                    </div>
                                                                </div>
                                                                <div className="commnet-body">
                                                                    <span>{comment.description}</span>
                                                                    {
                                                                        comment.attachments?.length ?
                                                                            <div className="comment-body-attachment">
                                                                                <span className="title"> {tr("attachment")}</span>
                                                                                <FileInput
                                                                                    multiple
                                                                                    readonly
                                                                                    value={comment.attachments}
                                                                                />
                                                                            </div>
                                                                            : ""
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div> : ""
                                }
                                {
                                    feedback.status !== FeedBackStatus.Closed && <div className="add-comment">
                                        <TextArea
                                            name="description"
                                            value={comment.description}
                                            placeholder={tr("feedback_add_comment_msg")}
                                            error={error.description}
                                            onChange={(name, value) => removeValidation(name, value)}
                                            onBlur={onCommentChange}
                                        />
                                        <div className="title">{tr("attachment")}</div>
                                        <FileInput
                                            name="attachments"
                                            value={comment?.attachments}
                                            multiple
                                            onChange={onFileAttachmentsChange}
                                            onRemove={onCommentChange}
                                        />
                                        <div className="flex justify-end">
                                            <Button
                                                height="40px"
                                                variant="contained"
                                                color="primary"
                                                text={tr("feedback_confirm")}
                                                loading={showCreateCommentLoading}
                                                onClick={onCreateCommentClick}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </Fragment>
                        : <ValueNotFound
                            title={tr("feedback_details_msg_not_found")}
                            iconSetting={{ mode: IconMode.File, path: valueNotFoundpng, width: "230px", height: "210px" }}
                        />
                }

            </div>
        </div>
    )
}

export default FeedbackDetails;